import { useState, useEffect } from 'react';
import { FormStatus } from '../util/app.types';
import { timeout, requestPasswordReset } from '../api';
import { validateEmail } from '../util/utils';

export const usePasswordReset = () => {
  const [formStatus, setFormStatus] = useState(FormStatus.Editing);
  const [mail, setMail] = useState('');
  const [invalidEmailWarning, setInvalidEmailWarning] = useState(false);

  useEffect(() => {
    const dispatch = async () => {
      setFormStatus(FormStatus.InFlight);
      await timeout(500);

      try {
        const result = await requestPasswordReset(mail);
        const json = await result.json();
        setFormStatus(json?.success ? FormStatus.Succeeded : FormStatus.Failed);
      } catch (e) {
        setFormStatus(FormStatus.Failed);
      }
    };
    if (mail) dispatch();
  }, [mail]);

  const submit = (mail: string) => {
    const isValid = validateEmail(mail);
    if (isValid) {
      setMail(mail);
    } else {
      setInvalidEmailWarning(true);
    }
  };

  return { formStatus, submit, invalidEmailWarning, mail };
};
